module.exports = __webpack_public_path__ + "static/15-a5c8874486522772efdc2f69bdecb942.jpeg";